/**
 * @file Trailer Type Selection.
 */
import { gsap } from 'gsap';

/**
 * Trailer Type Selection component.
 */
const vTrailerTypeSelection = () => {
	const accordion = document.querySelectorAll(
		'.v-trailer-type-selection__accordion',
	);
	const allAccordionContent = document.querySelectorAll(
		'.v-trailer-type-selection__accordion-content',
	);
	const allPlusIcons = document.querySelectorAll(
		'.v-trailer-type-selection__plus-icon',
	);
	const allMinusIcons = document.querySelectorAll(
		'.v-trailer-type-selection__minus-icon',
	);

	if (
		!accordion.length ||
		!allAccordionContent.length ||
		!allMinusIcons.length
	) {
		return;
	}

	gsap.set(allMinusIcons, {
		autoAlpha: 0,
	});

	gsap.set(allAccordionContent, {
		autoAlpha: 0,
	});

	accordion.forEach((el) => {
		const accordionContent = el.querySelector(
			'.v-trailer-type-selection__accordion-content',
		);
		const plusIcon = el.querySelector('.v-trailer-type-selection__plus-icon');
		const minusIcon = el.querySelector('.v-trailer-type-selection__minus-icon');

		el.addEventListener('click', () => {
			// Check if clicked acc is currently open
			const isOpen = gsap.getProperty(accordionContent, 'display') !== 'none';

			// Close all accordions
			// gsap.set(allAccordionContent, {
			// 	display: 'none',
			// 	autoAlpha: 0,
			// });
			// gsap.set(allMinusIcons, {
			// 	autoAlpha: 0,
			// });
			// gsap.set(allPlusIcons, {
			// 	autoAlpha: 1,
			// });

			// Toggle the clicked accordion based on its current state
			if (!isOpen) {
				// Show clicked accordion if it was closed
				gsap.set(accordionContent, {
					display: 'block',
				});
				gsap.to(accordionContent, {
					autoAlpha: 1,
				});
				gsap.set(plusIcon, {
					autoAlpha: 0,
				});
				gsap.to(minusIcon, {
					autoAlpha: 1,
				});
			} else {
				// Close this accordion
				gsap.set(
					el.querySelector('.v-trailer-type-selection__accordion-content'),
					{
						display: 'none',
						autoAlpha: 0,
					},
				);
				gsap.set(minusIcon, {
					autoAlpha: 0,
				});
				gsap.set(plusIcon, {
					autoAlpha: 1,
				});
			}
		});
	});

	// Find trailer searched for
	const urlParams = new URLSearchParams(window.location.search);
	const trailerName = urlParams.get('type');

	if(trailerName === null) {
		return;
	}

	const trailers = document.querySelectorAll(
		'.v-trailer-type-selection__accordion td',
	);
	if (trailers.length) {
		const trailerAccordion = Array.from(trailers).filter(
			(t) => t.textContent.toLowerCase() === trailerName.toLowerCase(),
		)[0];
		const accToOpen = trailerAccordion.closest(
			'.v-trailer-type-selection__accordion',
		);

		// Open accordion if searched for
		if (accToOpen) {
			gsap.set(
				accToOpen.querySelector('.v-trailer-type-selection__accordion-content'),
				{
					display: 'block',
				},
			);
			gsap.to(
				accToOpen.querySelector('.v-trailer-type-selection__accordion-content'),
				{
					autoAlpha: 1,
				},
			);
			gsap.set(
				accToOpen.querySelector('.v-trailer-type-selection__plus-icon'),
				{
					autoAlpha: 0,
				},
			);
			gsap.to(
				accToOpen.querySelector('.v-trailer-type-selection__minus-icon'),
				{
					autoAlpha: 1,
				},
			);

			setTimeout(() => {
				accToOpen.scrollIntoView();
			}, 1000);
		}
	}
};

export default vTrailerTypeSelection;
